import generic from './generic'

const getDefaultState = () => {
  return {
    all: [],
    details: [],
    errored: false,
    loading: false,
    fetchedAt: null,
    next: null,
    ageLimit: 180,
  }
}

const state = getDefaultState()

const mutations = {
  ...generic.mutations,
  'RESET': function (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  ...generic.actions,
  getAll (context) {
    return generic.getAll(context, {type: 'challenge'})
  },
  backgroundRefresh (context) {
    return generic.getAll(context, {type: 'challenge', hideLoading: true})
  },
}

const getters = {
  ...generic.getters,
  active (state) {
    return state.all.filter(obj => obj.is_active)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
